import { faBars, faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@heroui/react';
import { memo, useCallback, useState } from 'react';
import { useAuth } from '../auth/hooks/useAuth';
import { Link, useLocation } from '@tanstack/react-router';

function MobileSlideout() {
    const [menuShown, setMenuShown] = useState(false);
    const { logout, user } = useAuth();

    const toggleSlideOut = useCallback(() => {
        setMenuShown(x => {
            return !x;
        });
    }, []);

    const location = useLocation();
    const pathname = location.pathname;

    return (
        <div className='z-50 md:hidden'>
            <Button isIconOnly variant='light' onPress={toggleSlideOut} className='mr-4'>
                <FontAwesomeIcon icon={faBars} size='2x' className=' md:hidden' />
            </Button>

            <div
                className={`${
                    !menuShown ? 'h-0 w-0' : 'h-full w-full'
                } fixed left-0 top-0 h-full overflow-hidden bg-black bg-opacity-40 transition-all`}
                onClick={() => setMenuShown(false)}>
                <div
                    className=' h-full w-3/4  bg-white shadow-2xl shadow-black'
                    onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();
                    }}>
                    <div className='flex h-12 flex-row items-center border-b-2 border-gray-200 px-4'>
                        <div className='grow whitespace-nowrap text-xl font-bold'>
                            <h1 className='bg-linear-to-r from-green-500 to-teal-500 bg-clip-text text-xl font-bold tracking-tight text-transparent'>
                                Caddy Stats
                            </h1>
                        </div>
                        <Button
                            isIconOnly
                            variant='light'
                            className=' justify-self-end'
                            onPress={() => {
                                setMenuShown(false);
                            }}>
                            <FontAwesomeIcon icon={faClose} />
                        </Button>
                    </div>
                    <div className='grid gap-y-6 p-5 text-lg'>
                        {user ? (
                            <>
                                <Link
                                    to='/dashboard'
                                    onClick={toggleSlideOut}
                                    className={
                                        pathname === '/dashboard' || pathname === '/' ? 'text-primary' : ''
                                    }>
                                    Dashboard
                                </Link>
                                <Link
                                    to='/rounds'
                                    onClick={toggleSlideOut}
                                    className={pathname === '/rounds' ? 'text-primary' : ''}>
                                    Rounds
                                </Link>
                                <Link to='/account/teams' onClick={toggleSlideOut}>
                                    Teams
                                </Link>
                                <Link
                                    to='/courses'
                                    onClick={toggleSlideOut}
                                    className={pathname === '/courses' ? 'text-primary' : ''}>
                                    Courses
                                </Link>
                                {/* <Link href={PLAN_ROUTE} onPress={toggleSlideOut}>
                                    Subscription Plan
                                </Link> */}
                                {user?.is_admin && (
                                    <Link to='/account/admin' onClick={toggleSlideOut}>
                                        <span className='btn-underline'>Admin</span>
                                    </Link>
                                )}
                                <Link
                                    to='/account/settings'
                                    onClick={toggleSlideOut}
                                    className={pathname === '/account/settings' ? 'text-primary' : ''}>
                                    Settings
                                </Link>
                                <div
                                    onClick={() => {
                                        toggleSlideOut();
                                        logout();
                                    }}>
                                    Log Out
                                </div>
                            </>
                        ) : (
                            <>
                                <Link to='/' onClick={toggleSlideOut}>
                                    Home
                                </Link>
                                <Link to='/auth/login' onClick={toggleSlideOut}>
                                    Log in
                                </Link>
                                <Link to='/demo' onClick={toggleSlideOut}>
                                    Demo
                                </Link>
                                <Link to='/pricing' onClick={toggleSlideOut}>
                                    Pricing
                                </Link>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default memo(MobileSlideout);
